export enum ColorScaleType {
    CONSTANT = 'CONSTANT', // same color
    GRADIENT = 'GRADIENT',
    FIXED = 'FIXED', // list of colors
    INTERVAL = 'INTERVAL' // different color per interval
}
